import { cdlDef } from '../../cdl'

export default cdlDef({ id: 'CDLGRAVESTONEDOJI', label: 'Gravestone Doji', lookback: 10 })
